import { IdeyaButton } from '../../common/antd/ideya-button/ideya-button.tsx'
import { logout } from '../../utils/logout.ts'
import IdeyaTypography from '../../common/antd/ideya-typography.tsx'

export const Inactive = () => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          gap: '32px',
        }}
      >
        <IdeyaTypography.Title level={3}>
          Your account is currently inactive. Please contact support for
          assistance.
        </IdeyaTypography.Title>
        <div>
          <IdeyaButton type={'primary'} size={'large'} onClick={logout}>
            Logout
          </IdeyaButton>
        </div>
      </div>
    </>
  )
}
